import React, { useEffect, useState } from "react";
import { FaQuoteLeft, FaPlayCircle, FaStar } from "react-icons/fa";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { base_url } from "../utils/axiosConfig";
import Slider from "react-slick";
import { useNavigate } from "react-router-dom";

const Testimonials = () => {
  const [videoTestimonials, setVideoTestimonials] = useState([]);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [expandedCard, setExpandedCard] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [isPortrait, setIsPortrait] = useState(false);

  const handleVideoLoaded = (e) => {
    const { videoWidth, videoHeight } = e.target;
    setIsPortrait(videoHeight > videoWidth);
  };

  const handleClose = () => {
    setSelectedVideo(null);
    setIsPortrait(false);
  };

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);

        const [testRes] = await Promise.all([
          fetch(`${base_url}product/getTestimonialVideo`),
        ]);

        if (!testRes.ok) {
          throw new Error("Failed to fetch data");
        }

        const testData = await testRes.json();

        setVideoTestimonials(testData?.data?.testimonials || []);
      } catch (err) {
        toast.error(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);
  const testimonial = [
    {
      profession: "Tamil Actor",
      name: "Sharath Kumar",
      imgSrc: "/testimonials/user-1.jpeg",
      detail: "Innovative Product",
    },
    {
      profession: "Member of Lok Sabha",
      name: "Annasaheb Shankar Jolle",
      imgSrc: "/testimonials/user-2.jpeg",
      detail:
        "Highly advanced Medical & Digital Health Technology, I have seen the demo & appriciated , getting aligned with this company",
    },
    {
      profession:
        "BBM - Founder & Chairman of United Medicare Pte Ltd, Singapore ",
      name: "Robin NG",
      imgSrc: "/testimonials/user-3.jpeg",
      detail: "Very Good Medical Technology and Devices",
    },
    {
      profession: "Former Education Minister",
      name: "Suresh Kumar",
      imgSrc: "/testimonials/user-4.jpeg",
      detail: "Excellent Medical Health Technology",
    },

    {
      profession: "Actress, Bangalore",
      name: "Ragini Dwivedi",
      imgSrc: "/testimonials/user-5.jpeg",
      detail:
        " Having Spent Many Years on Research and Development on Innovative Medical Technology. Finally we got a very good product for Human Being. I Wish Mr. Rajanikanth and His Team great Success.",
    },
    {
      profession: "National University of Singapore",
      name: "Cynthia Chan",
      imgSrc: "/testimonials/user-6.jpeg",
      detail: "New Medical & Innovative Idea",
    },
  ];

  const settings2 = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const videoSettings = {
    dots: true,
    infinite: videoTestimonials.length > 4,
    speed: 600,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    arrows: false,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <>
      <style>{`/* Modal */
.portrait-modal .modal-dialog,
.landscape-modal .modal-dialog {
  margin: 1rem auto;
}

.portrait-modal .modal-content,
.landscape-modal .modal-content {
  border-radius: 16px;
  overflow: hidden;
}

/* Portrait videos */
.portrait-modal .modal-dialog {
  width: fit-content;
  max-width: min(420px, 95vw);
}

/* Landscape videos */
.landscape-modal .modal-dialog {
  width: fit-content;
  max-width: min(1100px, 95vw);
}

/* Body */
.video-modal-body {
  padding: 0;
  background: #000;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

/* Universal video */
.responsive-video {
  display: block;

  /* Never exceed viewport */
  max-width: 95vw;
  max-height: 80vh;

  width: auto;
  height: auto;

  object-fit: contain;
  background: #000;

  @media (max-width: 768px) {
  .portrait-modal .modal-dialog,
  .landscape-modal .modal-dialog {
    max-width: 98vw;
    margin: 0.5rem auto;
  }

  .responsive-video {
    max-width: 98vw;
    max-height: 70vh;
  }
}
}`}</style>
      {/* Hero */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <span className="text-[#35A93E] font-semibold uppercase tracking-wide">
              Testimonials
            </span>

            <h2 className="text-3xl md:text-4xl font-bold mt-2">
              What Our Customers Say
            </h2>

            <p className="text-gray-600 mt-3 max-w-2xl mx-auto">
              Hear directly from our members, partners, and customers about
              their experience with LifeOnPlus.
            </p>
          </div>

          <Slider {...settings2}>
            {testimonial.map((item, index) => (
              <div key={index} className="px-3">
                <div className="bg-white rounded-2xl shadow-sm hover:shadow-xl transition px-6 py-2 mx-2 min-h-[320px] flex flex-col">
                  {/* Quote */}
                  <div className="text-[#35A93E] text-4xl leading-none">❝</div>

                  {/* Avatar */}
                  <div className="flex justify-center mt-1 mb-2">
                    <div className="w-24 h-24 rounded-full overflow-hidden ring-4 ring-green-100">
                      <img
                        src={item.imgSrc}
                        alt={item.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                  </div>

                  {/* Rating */}
                  <div className="flex justify-center gap-1 mb-1">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <span key={star} className="text-yellow-400 text-lg">
                        ★
                      </span>
                    ))}
                  </div>

                  {/* Name */}
                  <h3 className="text-center text-sm font-semibold">
                    {item.name}
                  </h3>

                  <p className="text-center text-[#35A93E] text-xs font-medium mb-2">
                    {item.profession}
                  </p>

                  {/* Review */}
                  <p className="text-xs text-gray-600 leading-5 text-center flex-1 line-clamp-6">
                    {item.detail}
                  </p>
                </div>
              </div>
            ))}
          </Slider>

          <div className="text-center mt-10">
            <button
              onClick={() => navigate("/contact")}
              className="bg-[#35A93E] text-white px-8 py-3 rounded-xl hover:bg-green-700 transition"
            >
              Share Your Experience
            </button>
          </div>
        </div>
      </section>

      {/* ================= Video Testimonials ================= */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <span className="text-[#35A93E] font-semibold uppercase tracking-wide">
              Video Testimonials
            </span>

            <h2 className="text-3xl md:text-4xl font-bold mt-2">
              Watch Customer Experiences
            </h2>

            <p className="text-gray-600 mt-3 max-w-2xl mx-auto">
              Hear directly from our members, partners and customers about their
              experience with LifeOnPlus.
            </p>
          </div>

          <Slider {...videoSettings}>
            {videoTestimonials.map((video, index) => (
              <div key={index} className="px-3">
                <div
                  onClick={() => setSelectedVideo(video)}
                  className="group cursor-pointer bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100"
                >
                  {/* Thumbnail */}
                  <div className="relative h-64 bg-black flex items-center justify-center overflow-hidden">
                    <video
                      src={video}
                      muted
                      preload="metadata"
                      playsInline
                      className="w-full h-full object-contain"
                      onLoadedMetadata={(e) => {
                        // Capture a frame after 1 second
                        e.target.currentTime = 1;
                      }}
                      onMouseEnter={(e) => {
                        e.target.play();
                      }}
                      onMouseLeave={(e) => {
                        e.target.pause();
                        e.target.currentTime = 1;
                      }}
                    />

                    {/* Dark Overlay */}
                    <div className="absolute inset-0 bg-black/25 group-hover:bg-black/15 transition" />

                    {/* Play Button */}
                    <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                      <div className="w-16 h-16 rounded-full bg-white/90 flex items-center justify-center group-hover:scale-110 transition">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          className="w-8 h-8 text-[#35A93E] ml-1"
                        >
                          <path d="M8 5v14l11-7z" />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-[#35A93E] text-white">
        <div className="max-w-5xl mx-auto text-center px-4">
          <h2 className="text-3xl md:text-4xl font-bold">
            Share Your Experience
          </h2>

          <p className="mt-4 text-green-100 max-w-2xl mx-auto">
            We'd love to hear about your journey with LifeOnPlus. Your
            testimonial helps others make informed healthcare decisions.
          </p>

          <button
            onClick={() => (window.location.href = "/contact")}
            className="mt-8 bg-white text-[#35A93E] px-8 py-3 rounded-xl font-semibold hover:bg-gray-100 transition"
          >
            Submit Your Testimonial
          </button>
        </div>
      </section>

      {/* Video Modal */}
      <Modal
        show={!!selectedVideo}
        onHide={handleClose}
        centered
        dialogClassName={isPortrait ? "portrait-modal" : "landscape-modal"}
      >
        <Modal.Header closeButton>
          <Modal.Title>{selectedVideo?.name}</Modal.Title>
        </Modal.Header>

        <Modal.Body className="video-modal-body">
          {selectedVideo && (
            <video
              controls
              autoPlay
              playsInline
              onLoadedMetadata={handleVideoLoaded}
              className="responsive-video"
            >
              <source src={selectedVideo} type="video/mp4" />
            </video>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Testimonials;
